export const validateLimit = (limit) => {
  return typeof limit === 'number' && limit > 0 ? limit : undefined;
};
